// src/components/ImageSelectionPage.jsx
import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for redirection
import './ImageSelectionPage.css';

function ImageSelectionPage({ formData }) {
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate(); // Initialize navigate

  const handleImageSelect = async (imageName) => {
    const dataToStore = { ...formData, selectedImage: imageName };

    try {
      await addDoc(collection(db, 'submissions'), dataToStore);

      // Show success notification
      setNotification({ show: true, message: 'Modelo selecionado com sucesso!', type: 'success' });

      // Hide the notification and redirect to SuccessPage after 3 seconds
      setTimeout(() => {
        setNotification({ show: false, message: '', type: '' });
        navigate('/success'); // Redirect to SuccessPage
      }, 3000);
    } catch (error) {
      console.error('Error adding document:', error);

      // Show error notification
      setNotification({ show: true, message: 'Aconteceu algum erro. Favor tentar novamente.', type: 'error' });

      // Hide the error notification after 3 seconds
      setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
    }
  };

  return (
    <div className="image-selection-container">
      <div className="image-item" onClick={() => handleImageSelect('Esferas')}>
        <img src="./images/esferas.jpeg" alt="Image 1" className="image" />
        <p>Modelo 1</p>
        <p>Esferas Vortex Fidget</p>
        <p>Tempo: 1h</p>
      </div>
      <div className="image-item" onClick={() => handleImageSelect('Cell suport')}>
        <img src="./images/cel_suport.jpeg" alt="Image 2" className="image" />
        <p>Modelo 2</p>
        <p>Suporte Celular</p>
        <p>Tempo: 1h30</p>
      </div>

      {/* Custom Notification */}
      {notification.show && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}
    </div>
  );
}

export default ImageSelectionPage;
